/**
 * Toggle visibility of Tebi widget on page mount/unmount
 *
 * @returns {undefined}
 */
export function useRemoveTebi() {
	let el;

	onMounted(() => {
		el = document.getElementById('tebi_rs_01');
		if (el) {
			el.style.display = 'none';
		}
	});

	onBeforeUnmount(() => {
		if (el) {
			el.style.display = '';
		}
	});
}
